import { Component, Input, OnInit } from '@angular/core'
import { FormGroup, FormControl, Validators,  FormGroupDirective } from '@angular/forms'
import { CountryISO } from 'ngx-intl-tel-input'
import { countryCodeToCountryIso } from '../../../../../phone-utility'

@Component({
    selector: 'app-form-input-phone',
    templateUrl: 'form-input-phone.html',
    styleUrls: ['form-input-phone.scss']
})
export class FormInputPhoneComponent implements OnInit {

    @Input() label: string = 'Phone number'
    @Input() placeholderText: string = 'Enter your full name'
    @Input() fieldId: string = 'phoneNumber'
    @Input() darkTheme: boolean = false
    @Input() minLength: number = 3
    @Input() required: boolean = true
    @Input() countryCode: string
    @Input() modifierClassname: string
    @Input() useMinWidth = false

    CountryISO = CountryISO
    form: FormGroup

    constructor(private rootFormGroup: FormGroupDirective) {}

    ngOnInit(): void {
        this.countryCode = countryCodeToCountryIso(this.countryCode) || CountryISO.UnitedStates

        this.form = this.rootFormGroup.control;

        const validators = [
            this.required ? Validators.required : null,
        ].filter(Boolean)

        this.form.addControl(
            this.fieldId, 
            new FormControl('', validators)
        )
    }

    get control(){
        return this.form.get(this.fieldId)
    }
    
}
